
import { mapArrayToRecord } from "@base/util/TypeUtil";
import { FL } from "@biz/definitions/FL";
import { sojoInfos } from "@biz/definitions/LoungeDefinitions";
import { FeatureLevel } from "@biz/definitions/ProductDefinitions";
import { ClothType, SunSailType } from "@biz/definitions/SunSailDefinitions";
import { RaffType } from "@biz/items/raff/RaffDefinitions";
import { ClothData, IClothData } from "@biz/logic/ClothData";
import { PD } from "@biz/PD";
import { IProductDescriptor } from "@biz/ProductDescriptor";
import { IColorItem, SunSailColors } from "@biz/SunSailColors";

import type { IArticle } from "@biz/definitions/ArticleDefinitions";
export class ClothDataLogic {

  // static getClothAndColorForProduct(product: ISunSailData | ISail2dForm | IRaffData | ISCRaffData | INetData): { cloth: IClothData | undefined, colorId: string | undefined } {
  //   if (Product.isCurtain(product) || Product.isModelProduct(product) || Product.isLounge(product)) {
  //     throw new Error("GetClothForProduct not supported for cloth!")
  //   }
  //   const cloth = product.cloth;
  //   const colorId = product.colorId;
  //   //const cloth = ClothDataLogic.getCloth(product.cloth, PD.productToPD(product), fl);
  //   //const colorId = ClothDataLogic.getColorId(product.colorId, cloth, articleMap, colorMap, fl)
  //   //if (!cloth)
  //   //  return undefined;

  //   return {
  //     cloth,
  //     colorId

  //   }
  // }

  // static getCloth(cloth: IClothData | undefined, pd: IProductDescriptor, featureLevel: FeatureLevel): IClothData | undefined {
  //   const validItems = ClothDataLogic.calcValidClothDatasArray(pd, featureLevel);
  //   return getChecked({
  //     selection: cloth ?? ClothDataLogic.getDefaultClothData(pd, featureLevel)!,
  //     validItems,
  //     emptySelection: "__selectionRequired__",
  //     isEqual: ClothData.equals,
  //   })
  // }

  // static getColorId(colorId: string | undefined, articleId: string | IClothData | undefined, articleMap: Record<string, IArticle>, colorMap: Record<string, IColorItem>, featureLevel: FeatureLevel): string {
  //   const aid = articleId instanceof Object ? ClothData.getBaseArticleId(articleId) : articleId;
  //   return getChecked({
  //     selection: colorId,
  //     validItems: ClothDataLogic.getSortedColorsForArticle(aid || "", articleMap, colorMap, featureLevel),
  //     emptySelection: "__selectionRequired__",
  //   })!
  // }

  static calcValidClothDatasArray(pd: IProductDescriptor, featureLevel: FeatureLevel): IClothData[] {
    if (PD.isModelProduct(pd)) {
      if (pd.templateId === "sojo_sunbed") {
        return [
          ClothData.from(ClothType.Austrosail_Nano, { system: sojoInfos[pd.templateId].cloth, group: "936", type: "" }),
          ClothData.from(ClothType.Acrillia, { system: sojoInfos[pd.templateId].cloth, group: "701", type: "" }),
        ]
      } else if (pd.templateId === "sojo_sunseat") {
        return [
          ClothData.from(ClothType.Austrosail_Nano, { system: sojoInfos[pd.templateId].cloth, group: "936", type: "" }),
          ClothData.from(ClothType.Acrillia, { system: sojoInfos[pd.templateId].cloth, group: "701", type: "" }),
        ]
      } else if (pd.templateId === "sojo_sunbed_small") {
        return [
          ClothData.from(ClothType.Austrosail_Nano, { system: sojoInfos[pd.templateId].cloth, group: "936", type: "" }),
          ClothData.from(ClothType.Acrillia, { system: sojoInfos[pd.templateId].cloth, group: "701", type: "" }),
        ]
      } else if (pd.templateId === "beanbag") {
        return [ClothData.from(ClothType.Austrosail_Nano, { system: "CO", group: "936", type: "A01" })];
      } else if (pd.templateId === "drop") {
        return [
          ClothData.from(ClothType.Finoo, { system: "PEAR", group: "840", type: "" }),
          ClothData.from(ClothType.FinooPro, { system: "PEAR", group: "841", type: "" }),
          ClothData.from(ClothType.Telina, { system: "PEAR", group: "842", type: "" }),
          ClothData.from(ClothType.Austrosail_Nano, { system: "PEAR", group: "936", type: "" }),
          ClothData.from(ClothType.Acrillia, { system: "PEAR", group: "701", type: "" }),
        ];
      } else if (pd.templateId === "cat") {
        return [
          ClothData.from(ClothType.Finoo, { system: "CAT", group: "840", type: "" }),
          ClothData.from(ClothType.FinooPro, { system: "CAT", group: "841", type: "" }),
          ClothData.from(ClothType.Telina, { system: "CAT", group: "842", type: "" }),
          ClothData.from(ClothType.Austrosail_Nano, { system: "CAT", group: "936", type: "" }),
          ClothData.from(ClothType.Acrillia, { system: "CAT", group: "701", type: "" }),
        ];
      }
      return [
        ClothData.from(ClothType.Finoo, { system: "CO", group: "840", type: "A01" }),
        ClothData.from(ClothType.FinooPro, { system: "CO", group: "841", type: "A01" }),
        ClothData.from(ClothType.Telina, { system: "CO", group: "842", type: "A01" }),
        ClothData.from(ClothType.Austrosail_Nano, { system: "CO", group: "936", type: "A01" }),
        ClothData.from(ClothType.Acrillia, { system: "CO", group: "701", type: "A01" }),
      ]
    } else if (PD.isLounge(pd)) {
      return [
        // ClothData.from(ClothType.Finoo, { system: "CO", group: "840", type: "A01" }),
        ClothData.from(ClothType.FinooPro, { system: "CO", group: "841", type: "A01" }),
        ClothData.from(ClothType.Telina, { system: "CO", group: "842", type: "A01" }),
        ClothData.from(ClothType.Austrosail_Nano, { system: "CO", group: "936", type: "A01" }),
        ClothData.from(ClothType.Acrillia, { system: "CO", group: "701", type: "A01" }),
      ]
    } else if (PD.isRaff(pd)) {
      const system = "75";

      if (pd.sailMount === "hemstitch") {
        return [
          ClothData.from(ClothType.Austronet950, { system, group: "950", type: "J" }),
          ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "J" }),
        ].filter((i) => !!i);
      }

      return [
        ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "B" }),
        ClothData.from(ClothType.Austronet950, { system, group: "950", type: "B" }),
        ClothData.from(ClothType.Soltis92, { system, group: "792", type: "B" }),
        pd.raffType !== RaffType.M_Guide && ClothData.from(ClothType.SoltisW96, { system, group: "996", type: "B" }),
        ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "B" }),
        featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "B" }),
      ].filter((i) => !!i);
    } else if (PD.isCurtain(pd)) {
      const system = "54";
      return [
        ClothData.from(ClothType.Austrosail_Screen20, { system, group: "920", type: "A" }),
        ClothData.from(ClothType.Austrosail_Screen22, { system, group: "922", type: "A" }),
        ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }),
        ClothData.from(ClothType.ChillSail, { system, group: "939", type: "A" }),
        ClothData.from(ClothType.Austronet932, { system, group: "932", type: "A" }),
        ClothData.from(ClothType.Silvanet, { system, group: "201", type: "A" }),
        ClothData.from(ClothType.Finoo, { system, group: "840", type: "A" }),
      ]
    } else if (PD.isSail(pd)) {
      const { sunSailType, poleCount } = pd;
      switch (sunSailType) {
        case SunSailType.SolidayA: {
          const system = "73";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "rays" }),
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "rays" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "B" }, { textureType: "linear" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }, { textureType: "rays" }),
          ].filter((i) => !!i);
        }
        case SunSailType.SolidayOne: {
          if (poleCount === 3) {
            const system = "77";
            return [
              ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "rays" }), // Austrosail Nano strahlenf.
              ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "linear" }), // Austrosail Lotus 77393A
              ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }), // Austronet 950 77950A
            ]
          } else {
            const system = "78";
            return [
              ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "rays" }), // Austrosail Nano strahlenf.
              ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "linear" }), // Austrosail Lotus 77393A
              ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }), // Austronet 950 77950A
            ]
          }
        }
        case SunSailType.SolidayFlex: {
          if (FL.ge(featureLevel, "dealer")) {
            const system = "79";
            return [
              ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Austronet960, { system, group: "960", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "A" }, { textureType: "linear" }),
              featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }, { textureType: "linear" }),
            ].filter((i) => !!i);
          } else {
            const system = "82"; // https://plaspack.atlassian.net/browse/SSK-67
            return [
              ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "linear" }),
              ClothData.from(ClothType.Finoo, { system, group: "840", type: "A" }, { textureType: "linear" }),
            ]
          }
        }
        case SunSailType.SolidayX: {
          const system = "74";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "rays" }),
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "rays" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }, { textureType: "rays" }),
          ].filter((i) => !!i);
        }
        case SunSailType.SolidayXS: {
          const system = "76";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }),
            poleCount === 3 && ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "rays" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }),
          ].filter((i) => !!i);
        }
        case SunSailType.SolidayM: {
          const system = "70"
          return [
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }, { textureType: "linear" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }, { textureType: "rays" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "B" }, { textureType: "linear" }),
          ];
        }
        case SunSailType.SolidayC: {
          const system = "71";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { textureType: "rays" }),
            ClothData.from(ClothType.Soltis92, { system, group: "792", type: "A" }, { textureType: "rays" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }, { textureType: "rays" }),
          ].filter((i) => !!i);
        }
        case SunSailType.SolidayCS:
        case SunSailType.SolidayTwin: {
          const system = "72";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }),
            ClothData.from(ClothType.Soltis92, { system, group: "792", type: "A" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }),
          ].filter((i) => !!i);
        }
        case SunSailType.Standard: {
          const system = "612";
          return [
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "001" }),
            ClothData.from(ClothType.Soltis92, { system, group: "792", type: "001" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "001" }),

            ClothData.from(ClothType.Lotus, { system, group: "935", type: "001" }),
            ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "002" }, { glue: true }),
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "001" }, { glue: true }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "001" }, { glue: true }),
          ].filter((i) => !!i);
        }
        case SunSailType.Fixed: {
          const system = "60"
          // Reihenfolge: https://plaspack.atlassian.net/browse/SS-65
          const ret = [
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "B" }),
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }, { glue: true }),
            FL.ge(featureLevel, "dealer") && ClothData.from(ClothType.Austronet960, { system, group: "960", type: "B" }),
            ["user", "soliday"].includes(featureLevel) && ClothData.from(ClothType.Prestar, { system, group: "931", type: "A" }),
            ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }),
            ["user", "soliday"].includes(featureLevel) && ClothData.from(ClothType.Finoo, { system, group: "840", type: "A" }),
            ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }),
            ClothData.from(ClothType.Soltis92, { system, group: "792", type: "A" }),
            ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "AKL" }, { glue: true }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "B" }),
            FL.ge(featureLevel, "dealer") && pd.poleCount > 3 && ClothData.from(ClothType.ChillSail, { system, group: "939", type: "A" })
          ].filter((i) => !!i);
          return ret;
        }
        case SunSailType.Concept: {
          const system = "60";
          return [
            ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A3D" }),
            ClothData.from(ClothType.Austronet_Stretch, { system, group: "600", type: "A" }, { glue: true }),
            featureLevel === "soliday" && ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A3D" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Austronet960, { system, group: "960", type: "A3D" }),
            featureLevel === "soliday" && ClothData.from(ClothType.Concept, { system, group: "980", type: "A" }),
          ].filter((i) => !!i);;
        }
        case SunSailType.SandyRect: {
          const system = "50";
          return [
            ClothData.from(ClothType.Austronet932, { system, group: "932", type: "SR" }),
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "SR" }),
          ]
        }
        case SunSailType.SandyPoly: {
          const system = "50";
          return [
            ClothData.from(ClothType.Austronet932, { system, group: "932", type: "SR" }),
            ClothData.from(ClothType.Austronet950, { system, group: "950", type: "SR" }),
          ]
        }
      }
    } else if (PD.isNet(pd)) {
      const system = "50"; // todo...
      return [
        ClothData.from(ClothType.Austronet932, { system, group: "932", type: "A" }),
        ClothData.from(ClothType.Austronet950, { system, group: "950", type: "A" }),
        FL.ge(featureLevel, "dealer") && ClothData.from(ClothType.Austronet960, { system, group: "960", type: "A" }),
        ClothData.from(ClothType.Austrosail_Nano, { system, group: "936", type: "A" }),
        ["user", "soliday"].includes(featureLevel) && ClothData.from(ClothType.Prestar, { system, group: "931", type: "A" }),
        ClothData.from(ClothType.Lotus, { system, group: "393", type: "A" }),
        ClothData.from(ClothType.Austrosail_PES, { system, group: "935", type: "A" }),
        ClothData.from(ClothType.Finoo, { system, group: "840", type: "A" }),
        ClothData.from(ClothType.Soltis92, { system, group: "992", type: "A" }),
        ClothData.from(ClothType.Austrosail_Acryl, { system, group: "934", type: "A" }),
      ].filter((i) => !!i);;
    }
    return [];
  }

  static clothDataRecordFromArray(items: IClothData[]): Record<string, IClothData> {
    return mapArrayToRecord(items, (item) => ClothData.calcKey(item))
  }

  static isValidClothData(pd: IProductDescriptor, featureLevel: FeatureLevel, cloth: IClothData): boolean {
    const validClothDatas = ClothDataLogic.calcValidClothDatasArray(pd, featureLevel)
    for (const cd of validClothDatas) {
      if (ClothData.equals(cd, cloth))
        return true;
    }
    return false;
  }

  static getDefaultClothData(productDescriptor: IProductDescriptor, featureLevel: FeatureLevel): IClothData | undefined {
    const clothDatas = ClothDataLogic.calcValidClothDatasArray(productDescriptor, featureLevel);
    if (clothDatas.length > 0) return clothDatas[0];
    return undefined;
  }

  static getInitialColorId(cloth: IClothData | undefined, articles: Record<string, IArticle>, colorMap: Record<string, IColorItem>, featureLevel: FeatureLevel): string {
    if (!cloth)
      return "";

    const clothArticleId = ClothData.getBaseArticleId(cloth);
    const article = articles[clothArticleId];
    if (!article)
      return "";
    const colors = ClothDataLogic.getSortedColorsForArticle(clothArticleId, articles, colorMap, featureLevel);
    return SunSailColors.getFirstAvailableColor(colors, colorMap)
  }


  static getColorsForArticle(articleId: string, articleMap: Record<string, IArticle>, featureLevel: FeatureLevel): string[] {
    const article = articleMap[articleId];
    if (!article) return [];

    if (article.colorGroup) {
      let colors = article.colorGroup.items.map((c) => c.variantId);
      if (featureLevel === "user") {
        colors = colors.filter((v) => !["936B102", "936998"].includes(v)); // https://plaspack.atlassian.net/browse/SSK-56
      }
      return colors;
    }

    return [];
  }

  static getSortedColorsForArticle(articleId: string, articleMap: Record<string, IArticle>, colorMap: Record<string, IColorItem>, featureLevel: FeatureLevel): string[] {
    return SunSailColors.sortColorsByPriority(ClothDataLogic.getColorsForArticle(articleId, articleMap, featureLevel), colorMap);
  }

  static getColorsForArticles(articleIds: string[], articleMap: Record<string, IArticle>, featureLevel: FeatureLevel): string[] {
    let ret: string[] = [];
    for (const a of articleIds) {
      ret = ret.concat(ClothDataLogic.getColorsForArticle(a, articleMap, featureLevel));
    }
    return ret;
  }

  static getProtectionColors(articleMap: Record<string, IArticle>, featureLevel: FeatureLevel, withStone: boolean): string[] {
    const articles = ClothDataLogic.getColorsForArticle("70935A", articleMap, featureLevel);
    const stoneId = "935653";
    return withStone ? articles.sort((a, b) => (b === stoneId ? 1 : 0) - (a === stoneId ? 1 : 0)) : articles.filter((v) => v !== stoneId);
  }

  static calcValidClothDatasArrayWithAvailableColors(pd: IProductDescriptor, articleMap: Record<string, IArticle>, colorMap: Record<string, IColorItem>, featureLevel: FeatureLevel): IClothData[] {
    const validClothDatas = ClothDataLogic.calcValidClothDatasArray(pd, featureLevel);
    return validClothDatas.filter((cloth) => {
      const clothArticleId = ClothData.getBaseArticleId(cloth);
      const colorIds = ClothDataLogic.getColorsForArticle(clothArticleId, articleMap, featureLevel);
      const colors = colorIds.find((colorId) => {
        const colorItem = colorMap[colorId];
        const availability = colorItem.availability;
        return (availability === "available");
      });

      return colors !== undefined;
    });
  }
}
